import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import LiveCoachingSource from 'sources/scorecards/LiveCoachingSource';

class LiveCoachingActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('createEmpty', 'update', 'directions', 'retrieveForCall'),
      'scorecardSubmitted',
      'setCallRecordingLink',
      'reset'
    );
  }

  createEmpty([callerId, coachId]) {
    return dispatch => {
      dispatch([callerId, coachId]);
      return LiveCoachingSource.createEmpty(callerId).then(
        this.createEmptySuccess,
        this.createEmptyError
      );
    };
  }

  update(call) {
    return dispatch => {
      dispatch(call);
      return LiveCoachingSource.update(call).then(this.updateSuccess, e => {
        this.updateError(e);
        throw e;
      });
    };
  }

  directions(callerId) {
    return dispatch => {
      dispatch(callerId);
      return LiveCoachingSource.directions(callerId).then(
        this.directionsSuccess,
        this.directionsError
      );
    };
  }

  setGeneralComments(generalComments) {
    return dispatch => {
      dispatch(generalComments);
    };
  }

  retrieveForCall(callId) {
    return dispatch => {
      dispatch(callId);

      return LiveCoachingSource.retrieveForCall(callId).then(
        r => this.retrieveForCallSuccess([callId, r]),
        this.retrieveForCallError
      );
    };
  }
}

export default alt.createActions(LiveCoachingActions);
